export class CachedValue {
    constructor(ttl) {
        this.ttl = ttl;
        this.savedValue = undefined;
    }
    get() {
        if (this.lastSaved && this.lastSaved.getTime() > Date.now() - this.ttl) {
            return this.savedValue;
        }
        return undefined;
    }
    set(valueToCache) {
        this.savedValue = valueToCache;
        this.lastSaved = new Date();
    }
    clear() {
        this.savedValue = undefined;
        this.lastSaved = undefined;
    }
}
//# sourceMappingURL=CachedValue.js.map